export default __webpack_public_path__ + "img/f997f0112132f676a131aec24e6b14f0.png";